import React from 'react';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

interface StyleSheetManagerSetupProps {
  children: React.ReactNode;
}

// styled-components props 필터링을 위한 함수
const shouldForwardProp = (prop: string) => {
  // DOM에 전달하면 안 되는 props 목록
  const blockedProps = [
    'scrolled',
    'active', 
    'isActive',
    'isRight',
    'isHovered',
    'hasHoveredItem',
    'hoveredItemIsSpecial',
    'isSpecial',
    '$scrolled',
    '$active',
    '$isActive',
    '$isRight',
    '$isHovered',
    '$hasHoveredItem',
    '$hoveredItemIsSpecial',
    '$isSpecial'
  ];
  
  // 블록된 props가 아니고, emotion의 isPropValid도 통과하는 경우만 전달
  return !blockedProps.includes(prop) && isPropValid(prop);
};

const StyleSheetManagerSetup: React.FC<StyleSheetManagerSetupProps> = ({ children }) => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      {children}
    </StyleSheetManager>
  );
};

export default StyleSheetManagerSetup;
